<template>
  <div>
    <nav-bar
      v-on:getLatLong="onLocationClick"
      :settingData="$auth.setting"
    ></nav-bar>
    <section class="resturant-main tab-content header-top">
      <div
        class="slider-home-top cust-slider-top"
        v-if="$auth && $auth.setting && cateMenus.length > 0"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <home-slider
                v-if="
                  showBanner &&
                  $auth &&
                  $auth.setting &&
                  $auth.getVendorId() > 0
                "
                :v-on:getRestaurantData="getRestaurantByBanner"
                :v-on:getMobileLatLong="onLocationClick"
                :locationData="filter"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="hme-res-itm mb-5" v-if="iscateMenusLoader">
              <div
                class="filter-title justify-content-between align-items-center mb-4"
              >
                <h4>
                  <skeleton-loader-vue
                    type="string"
                    width="24%"
                    height="20px"
                    style="bottom: 11px"
                  />
                </h4>
                <p class="mb-0">
                  <skeleton-loader-vue
                    type="string"
                    width="30%"
                    height="20px"
                  />
                </p>
              </div>
              <div
                id="resturant-item-main2"
                class="resturant-item-main resturant-item-skeleton"
              >
                <a
                  href="javascript:void(0)"
                  v-for="itemcount in 6"
                  :key="itemcount"
                >
                  <div class="resturant-item d-flex align-items-start">
                    <skeleton-loader-vue class="skel-img-cls" type="string" />

                    <div class="resturant-data">
                      <h4>
                        <skeleton-loader-vue
                          type="string"
                          height="20px"
                          width="135px"
                        />
                      </h4>
                      <div class="res-price-main mt-2 d-flex">
                        <div>
                          <skeleton-loader-vue
                            type="string"
                            width="44px"
                            height="24px"
                          />
                        </div>
                        <ul
                          class="time-price d-flex justify-content-center mb-0 ms-3"
                        >
                          <li>
                            <skeleton-loader-vue
                              type="string"
                              width="44px"
                              height="24px"
                            />
                          </li>
                          <li>
                            <span></span
                            ><skeleton-loader-vue
                              type="string"
                              width="44px"
                              height="24px"
                            />
                          </li>
                        </ul>
                      </div>
                      <div class="offer-sec">
                        <p class="mb-0 mt-1"></p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="hme-res-itm"
              v-if="$auth.setting && !iscateMenusLoader && cateMenus.length > 0"
            >
              <home-title :title="$t('Restaurants nearby')"> </home-title>
              <div id="resturant-item-main">
                <div class="resturant-item-main">
                  <item
                    v-for="item in cateMenus"
                    :key="item.restaurant_id"
                    :item="item"
                    :isPickupDelivery="filter.is_pickup_delivery"
                    :isSchedule="true"
                    :webVendorLayout="2"
                    components=""
                  >
                  </item>
                  <!-- <item v-for=" item in cateMenus" :key="item.restaurant_id" :item="item"
                    :isPickupDelivery="filter.is_pickup_delivery"
                    :isSchedule="false"
                    :webVendorLayout="webVendorListingLayout" components="">
                  </item> -->
                </div>
                <!-- <div class="home-res-not-found mt-5" >
                  <div class="nostr-img-cls">
                    <img src="@/assets/images/no_store.png" />
                    <div class="no-txt-fnd">{{ $t('Service not available') }}</div>
                    <span>{{ $t('Service not available in this area. Please change location and try again.') }}</span>
                  </div>
                </div> -->
              </div>
            </div>
            <SystemMessage
              v-if="
                cateMenusNotFound &&
                this.$auth.setting &&
                cateMenus.length == 0 &&
                !iscateMenusLoader
              "
            ></SystemMessage>
          </div>
        </div>
      </div>
    </section>

    <BusinessClosedModal />

    <!-------------Coupen Modal Start----------------------->
    <div
      class="modal fade order-placed"
      data-backdrop="static"
      data-keyboard="false"
      id="coupenModal"
      tabindex="-1"
      aria-labelledby="coupenModallabel"
      aria-hidden="true"
      ref="coupenModalRef"
      style="z-index: 9999"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content coupenmodal">
          <div class="modal-header">
            <h4 class="modal-title" id="filterLabel"></h4>
            <a data-dismiss="modal" class="lnk">
              <!-- {{ $t("Close") }} -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
          <div class="modal-body text-center">
            <img :src="promoDetails.coupon_image" />
            <h4>{{ promoDetails.coupon_name }}</h4>
            <p>{{ promoDetails.description }}</p>
          </div>
          <div class="modal-footer full-btn d-block">
            <a
              href="javascript:void(0);"
              @click="doCopy(promoDetails.coupon_code)"
              data-dismiss="modal"
              >{{ $t("Copy") }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-------------Coupen Modal End----------------------->

    <!--Alert Modal start-->
    <AlertModal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      v-on:modalClose="onModalCloseFun"
    ></AlertModal>
    <!--Alert Modal End-->
    <a
      v-if="whatsappSupport != ''"
      :href="'https://api.whatsapp.com/send?phone=' + whatsappSupport"
      class="float"
      target="_blank"
    >
      <img class="wp-button" src="@/assets/images/whatsapp-icon.png" />
    </a>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Item from "@/components/Item.vue";
import { mapActions, mapGetters } from "vuex";
import HomeSlider from "@/components/HomeSlider.vue";
import HomeTitle from "@/components/HomeTitle.vue";
import BusinessClosedModal from "@/components/BusinessClosedModal.vue";
import NavBar from "@/components/NavBar.vue";
import AlertModal from "../components/AlertModal.vue";
import couponlist from "../components/CouponList.vue";
import Footer from "../components/Footer.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import SystemMessage from "@/components/SystemMessage.vue";

export default {
  name: "Home",
  components: {
    HomeSlider,
    HomeTitle,
    NavBar,
    Item,
    AlertModal,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    couponlist,
    VueSlickCarousel,
    SystemMessage,
    BusinessClosedModal,
  },
  data() {
    return {
      pagename: "home",
      loading: true,
      setting: {},
      addres: "",
      latitude: "",
      filter: {
        lat: "",
        lng: "",
        city: "",
        state: "",
        is_pickup_delivery: 2,
      },
      marker: {
        position: {
          lat: 0,
          lng: 0,
        }
      },
      skip: 0,
      showBanner: false,
      whatsappSupport: "",
      isAlert: false,
      cateMenus: [],
      iscateMenusLoader: true,
      cateMenusNotFound: true,
      promoDetails: {},
      isSelectCoupon: "",
      settings: {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 8,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 8,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              initialSlide: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      newsettings: {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              initialSlide: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              infinite: false,
            },
          },
        ],
      },
      displayMSG: "",
    };
  },
  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.name == "reservation") {
        this.$store.commit("order/pickupdelivery", "2");
      }
      if (this.$auth.setting && this.filter.lat != "") {
        // window.addEventListener("scroll", () => {
        //   if (
        //     window.innerHeight + window.scrollY >=
        //     document.body.offsetHeight
        //   ) {
        // if (!this.isStopCallingApi) {
          // }
          // }
          // });
        }
        

        this.filter.lat = parseFloat(localStorage.getItem("latitude")) || "0";
        this.filter.lng = parseFloat(localStorage.getItem("longitude")) || "0";
        this.displayMSG = this.$auth?.setting?.delay_message ?? "";

        if(this.filter.lat == '0' || this.filter.lng == '0'){
          this.locatorButtonPressed();
        }else{
          this.getRestaurant();
        }

      // this.getRestaurant();

    }, 1500);
  },

  methods: {
    ...mapActions("restaurant", ["getDineRestaurants"]),


     locatorButtonPressed() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: parseFloat(position.coords.latitude),
          lng: parseFloat(position.coords.longitude),
        };
        localStorage.setItem("latitude", parseFloat(position.coords.latitude));
        localStorage.setItem(
          "longitude",
          parseFloat(position.coords.longitude)
        );

        this.filter.lat = parseFloat(position.coords.latitude);
        this.filter.lng =parseFloat(position.coords.longitude)
          this.getRestaurant();
      });
      this.onclick = "yes";
      localStorage.setItem("geolocation", "yes");
    },
    

    coupenModalPopup(value) {
      this.promoDetails = value;
      window.$(this.$refs.coupenModalRef).modal();
    },

    doCopy(el) {
      this.isSelectCoupon = el;
      this.$copyText(el).then(function (e) {
        navigator.clipboard.writeText(e.text);
      });
      this.$toasted.success(this.$t("Promocode Copied to clipboard."), {
        duration: 2000,
      });
    },
    /*************
     * Close Alert Modal component
     *
     *************/
    onModalCloseFun(value) {
      this.isAlert = false;
    },
    /*************
     *
     * Select location to get address and latitude and longitude to call function
     *
     *************/
    onLocationClick(value) {
      this.cateMenus = [];
      if (value.lat && value.lng) {
        this.filter.lat = parseFloat(value.lat);
        this.filter.lng = parseFloat(value.lng);
      } else {
        this.filter.lat = parseFloat(localStorage.getItem("latitude"));
        this.filter.lng = parseFloat(localStorage.getItem("longitude"));
      }
      this.filter.city = value.city;
      this.filter.state = value.state;
      this.skip = 0;
      // this.isStopCallingApi = false;

      // this.getRestaurant();
      setTimeout(() => {
        if (value.onclick == "yes") {
          this.getRestaurant();
        }
      }, 2000);
      this.showBanner = true;
    },

    /*************
     *
     * First home slider banner call in function emit
     *
     *************/
    getRestaurantByBanner(value) {
      this.getRestaurant();
    },

    /*************
     *
     * Multivendor for restaurnat and business category list
     * Single Restaurnat for menu category Display
     *
     *************/
    getRestaurant() {
      if (this.$auth.setting && this.filter.lat != "") {
        this.iscateMenusLoader = true;
        this.getDineinRestaurant();
      }
    },

    getDineinRestaurant() {
      this.getDineRestaurants({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        latitude: this.filter.lat,
        longitude: this.filter.lng,
        delivery_type_time_slots: 3,
      }).then((data) => {
        if (data.code == 200) {
          this.cateMenus = data.Result;
          // this.cateMenus = [];
          this.iscateMenusLoader = false;
          // if(data.Result.menu_category_count > 0){
          this.showBanner = true;
          // }
          this.cateMenusNotFound = this.cateMenus.length <= 0;
          localStorage.setItem("geolocation", "");
        } else if (data.code == 101) {
          this.cateMenus = [];
          this.cateMenusNotFound = true;
          this.iscateMenusLoader = false;
          localStorage.setItem("geolocation", "");
        } else {
          this.cateMenus = [];
          this.iscateMenusLoader = false;
        }
      });
    },
  },
};
</script>
